import generateHandleActions from 'redux/state-handler';
import {
  CLEAR_CONFIRM_MESSAGE,
  CLEAR_HEADER_TITLE,
  CLEAR_HELP_CONTENT,
  CLEAR_ORDER_CART,
  CLEAR_SEARCH_CONTENT,
  CLEAR_SIDEBAR_ITEMS,
  CLEAR_SIDEBAR_OPEN,
  CLEAR_FILTER_CATEGORY,
  GLOBAL_NOTIFICATION,
  SET_CONFIRM_ACTION,
  SET_CONFIRM_MESSAGE,
  SET_HEADER_TITLE,
  SET_HELP_CONTENT,
  SET_HOT_NOTIFICATION,
  SET_LOCALE,
  SET_ORDER_CART,
  SET_PAGINATION,
  SET_PRINT_CONTENT,
  SET_SCROLL_TOP,
  SET_SEARCH_CONTENT,
  SET_SIDEBAR_ITEMS,
  SET_SIDEBAR_OPEN,
  SET_FILTER_CATEGORY,
} from 'redux/constants';

const apiStates = [];
const instantStates = [
  { type: CLEAR_CONFIRM_MESSAGE, name: 'confirmMessage', kind: 'object' },
  { type: CLEAR_SIDEBAR_ITEMS, name: 'sidebarItems', kind: 'object' },
  { type: CLEAR_SIDEBAR_OPEN, name: 'sidebarOpen' },
  { type: CLEAR_HEADER_TITLE, name: 'headerTitle' },
  { type: CLEAR_HELP_CONTENT, name: 'helpContent' },
  { type: CLEAR_ORDER_CART, name: 'orderCart' },
  { type: CLEAR_SEARCH_CONTENT, name: 'searchContent' },
  { type: GLOBAL_NOTIFICATION, name: 'notification', kind: 'object' },
  { type: SET_CONFIRM_ACTION, name: 'confirmAction', kind: 'object' },
  { type: SET_CONFIRM_MESSAGE, name: 'confirmMessage', kind: 'object' },
  { type: SET_HEADER_TITLE, name: 'headerTitle' },
  { type: SET_HELP_CONTENT, name: 'helpContent' },
  { type: SET_HOT_NOTIFICATION, name: 'hotNotification' },
  { type: SET_LOCALE, name: 'locale' },
  { type: SET_ORDER_CART, name: 'orderCart' },
  { type: SET_PAGINATION, name: 'pagination' },
  { type: SET_PRINT_CONTENT, name: 'printContent' },
  { type: SET_SCROLL_TOP, name: 'scrollTop' },
  { type: SET_SEARCH_CONTENT, name: 'searchContent' },
  { type: SET_SIDEBAR_ITEMS, name: 'sidebarItems', kind: 'object' },
  { type: SET_SIDEBAR_OPEN, name: 'sidebarOpen' },
  { type: CLEAR_FILTER_CATEGORY, name: 'filterCategory' },
  { type: SET_FILTER_CATEGORY, name: 'filterCategory' },
];
const storage = {
  locale: 'locale',
};

const listValues = ['staticComponents', 'helpContent', 'sidebarItems', 'searchContent', 'orderCart', 'filterCategory'];

export default generateHandleActions({ apiStates, instantStates, storage, listValues });
